import { useQuery } from '@tanstack/react-query';
import { employeesService } from '../services/employees.service';
import type { EmployeeFilters } from '../types/employees.types';

export function useEmployees(companyRefId: string, filters?: EmployeeFilters) {
  return useQuery({
    queryKey: ['employees', companyRefId, filters],
    queryFn: () => employeesService.getEmployees(companyRefId, filters),
    enabled: Boolean(companyRefId?.trim()),
  });
}
